import axios from "axios";

function CampaignsService() {
    let controller = null;
    const init = () => controller = new AbortController();
    const dispose = () => { if (controller) controller.abort(); controller = null; };
    const config = () => controller && controller.signal ? { signal: controller.signal } : null;

    const get = (isLanding = false) => axios
        .get(`/campaigns?landing=${isLanding}`, config())
        .catch(error => error);

    return {
        init,
        dispose,
        get
    };
}

export default CampaignsService;